import React, { useRef } from 'react';
import { InlineInput } from '../../../../Common/DesignSystem/InlineInput';
import Icon from '../../../../Common/DesignSystem/Icons/Icon';
import colours from '../../../../Common/DesignSystem/Colours';

const InputContainer = ({ children }) => (
  <div style={{ display: 'flex', flexDirection: 'row', gap: '24px' }}>
    {children}
  </div>
);

export const OrderInformation = ({ inventoryForm, updateInventoryForm, isConvertingToVehicle }) => {
  const offlineDateRef = useRef();
  const fhiDepartureRef = useRef();
  const vesselEtaRef = useRef();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <div style={{ marginBottom: '8px', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '4px' }}>
        <h4>Order Information</h4>
        <Icon name="Link" size={24} style={{ color: colours.primary.grey02 }} />
      </div>

      <InputContainer>
        <InlineInput isInputOpen={!isConvertingToVehicle} label="Model Code" name="modelCode" required value={inventoryForm.modelCode} onChange={updateInventoryForm} inputFlex={2} />
        <InlineInput isInputOpen={!isConvertingToVehicle} label="Order Number" name="orderNo" required value={inventoryForm.orderNo} onChange={updateInventoryForm} inputFlex={2} />
        <InlineInput isInputOpen={!isConvertingToVehicle} label="Offline Date" name="offlineDate" placeholder="MM-DD-YYYY" id="orderFormOfflineDate" datepicker trailing_ic="Calendar" value={inventoryForm.offlineDate === 'Invalid date' ? '' : inventoryForm.offlineDate} onChange={updateInventoryForm} ref={offlineDateRef} inputFlex={2} />
      </InputContainer>
      <InputContainer>
        <InlineInput isInputOpen={!isConvertingToVehicle} label="Ship To" name="shipTo" value={inventoryForm.shipTo} onChange={updateInventoryForm} inputFlex={2} />
        <InlineInput isInputOpen={!isConvertingToVehicle} label="Reason For Order" name="reasonForOrder" value={inventoryForm.reasonForOrder} onChange={updateInventoryForm} inputFlex={2} />
        <InlineInput isInputOpen={!isConvertingToVehicle} label="FHI Departure" name="fhiDeparture" placeholder="MM-DD-YYYY" id="orderFormFhiDeparture" datepicker trailing_ic="Calendar" value={inventoryForm.fhiDeparture === 'Invalid date' ? '' : inventoryForm.fhiDeparture} onChange={updateInventoryForm} ref={fhiDepartureRef} inputFlex={2} />
      </InputContainer>
      <InputContainer>
        <InlineInput isInputOpen={!isConvertingToVehicle} label="Location Status" name="locationStatus" value={inventoryForm.locationStatus} onChange={updateInventoryForm} inputFlex={2} />
        <InlineInput isInputOpen={!isConvertingToVehicle} label="Dealer ID" name="dealerId" required value={inventoryForm.dealerId} onChange={updateInventoryForm} inputFlex={2} />
        <InlineInput isInputOpen={!isConvertingToVehicle} label="Vessel ETA" name="vesselEta" placeholder="MM-DD-YYYY" id="orderFormVesselEta" datepicker trailing_ic="Calendar" value={inventoryForm.vesselEta === 'Invalid date' ? '' : inventoryForm.vesselEta} onChange={updateInventoryForm} ref={vesselEtaRef} inputFlex={2} />
      </InputContainer>
    </div>
  );
};
